module.exports = __webpack_public_path__ + "static/media/stream.730588b4.png";